import { render, staticRenderFns } from "./NotificationCenterBackend.vue?vue&type=template&id=68370401&scoped=true&"
import script from "./NotificationCenterBackend.vue?vue&type=script&lang=js&"
export * from "./NotificationCenterBackend.vue?vue&type=script&lang=js&"
import style0 from "./NotificationCenterBackend.vue?vue&type=style&index=0&id=68370401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68370401",
  null
  
)

export default component.exports